import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { DeliberyNoteServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the DeliberyNoteCreatePartialIngprodSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-delibery-note-create-partial-ingprod-selected',
    templateUrl: 'delibery-note-create-partial-ingprod-selected.html',
})
export class DeliberyNoteCreatePartialIngprodSelectedPage {
    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public deliberyNoteServices: DeliberyNoteServices,
        public translate: TranslateService,) {

    }

    ionViewWillEnter() {
    }

    delete(element) {
        var index = this.deliberyNoteServices.prodings_array_tmp.findIndex(x => x[0] == element[0]);
        if (index >= 0) {
            this.deliberyNoteServices.prodings_array_tmp.splice(index, 1);
            this.deliberyNoteServices.prodings_array_tmp = [...this.deliberyNoteServices.prodings_array_tmp];
        }
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.delete(event.row);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-selected/delibery-note-create-partial-ingprod-selected.ts